<template>
  <div class="consoleWindow" id="consoleWindow" ref="consoleWindow">
    <span v-for="message in consoleMessages" v-bind:key="message">{{message}}<br></span>
    <span class="userInput" ref="scrollToMe">~> {{userInput}}
      <!--<input type="text" v-model="userInput" autofocus @keyup.enter="this.execute()">-->
    </span>
    <div style="height: 7%;"></div>
  </div>
</template>

<script>

export default {
  name: 'TerminalEmulator',
  data() {
    return {
      consoleMessages: [],
      userInput: '',
      userInputLog: [],
      files: [],
      smileyFace: '(¬‿¬ )',
      terminalFontColor: '#fff',
      terminalBackgroundColor: '#000',
      screenRadius: '0px',
    }
  },
  mounted() {
    this.setRandomSmileyFace();
    this.setRandomTerminalFontColor();
    this.setRandomTerminalBackgroundColor();
    this.setRandomScreenRadius();

    this.addMessageToConsole("Hello! I'm picocomputer! "+this.smileyFace);
    this.addMessageToConsole("Type 'help' to see a list of commands");
    this.addMessageToConsole("");

    this.files = window.localStorage.getItem('files') ? JSON.parse(window.localStorage.getItem('files')) : [];

    window.addEventListener("keydown", function(e) {

      switch(e.key) {
        case "Enter":
          this.execute();
          break;
        case "Backspace":
          this.userInput = this.userInput.slice(0, -1);
          break;
        case "Shift":
        case "CapsLock":
        case "Escape":
        case "Meta":
        case "Control":
        case "Alt":
        case "ArrowLeft":
          //
          break;
        case "ArrowRight":
          //
          break;
        case "ArrowUp":
          this.userInput = this.userInputLog[this.userInputLog.length - 1];
          break;
        
        case "ArrowDown":
          this.userInput = this.userInputLog[this.userInputLog.length];
          break;
        
        default:
          this.userInput += e.key;
          break;
      }

    }.bind(this));

    this.$parent.setFeatures(this.smileyFace, this.terminalFontColor, this.terminalBackgroundColor, this.screenRadius);

  },
  methods: {
    addMessageToConsole(message) {
      this.consoleMessages.push(message);
      this.scrollToElement();
    },
    execute(){
      this.userInputLog.push(this.userInput);
      this.addMessageToConsole("~> "+this.userInput);
      switch(this.userInput){
        case "clear":
          this.consoleMessages = [];
          break;
        case "":
          this.addMessageToConsole("");
          break;

        case this.checkInputForWord(this.userInput, "cat"):
          var param = this.userInput.split(" ");
          var file = window.localStorage.getItem(param[1]);
          if(file){
            this.addMessageToConsole(file);
          } else {
            if(param[1] == undefined){
              this.addMessageToConsole("Please specify a file name");
            } else {
              this.addMessageToConsole("File not found");
            }
          }
          break;

        case this.checkInputForWord(this.userInput, "rm"):

          param = this.userInput.split(" ");
          
          if(param[1] == "*"){
            window.localStorage.clear();
            this.addMessageToConsole("All files deleted");
          } else {

            if(!window.localStorage.getItem(param[1])){
              this.addMessageToConsole("File "+param[1]+" not found");
              break;
            }
            file = window.localStorage.removeItem(param[1]);

            var allFiles = JSON.parse(window.localStorage.getItem("files"));
            var index = allFiles.indexOf(param[1]);
            allFiles.splice(index, 1);
            window.localStorage.setItem("files", JSON.stringify(allFiles));

            this.addMessageToConsole("File "+param[1]+" deleted");

          }

          break;

        case this.checkInputForWord(this.userInput, "mv"):

          param = this.userInput.split(" ");

          if(!window.localStorage.getItem(param[1])){
            if(param[1] == undefined){
              this.addMessageToConsole("Please specify a file name");
            } else {
              this.addMessageToConsole("File not found");
            }
            break;
          }

          if(param[2] == undefined){
            this.addMessageToConsole("Please specify a new file name");
            break;
          }

          window.localStorage.setItem(param[2], window.localStorage.getItem(param[1]));

          file = window.localStorage.removeItem(param[1]);

          allFiles = JSON.parse(window.localStorage.getItem("files"));
          index = allFiles.indexOf(param[1]);
          allFiles.splice(index, 1);
          allFiles.push(param[2]);
          window.localStorage.setItem("files", JSON.stringify(allFiles));

          this.addMessageToConsole("File "+param[1]+" moved as "+param[2]);

          break;

        case this.checkInputForWord(this.userInput, "run"):

          param = this.userInput.split(" ");

          if(!window.localStorage.getItem(param[1])){
              this.addMessageToConsole("File "+param[1]+" not found");
              break;
          }

          this.executeJsFile(param[1]);
          break;

        case this.checkInputForWord(this.userInput, "file"):
          param = this.userInput.split(" ");
          if(param[0] == "file"){
            var fileName = param[1];
            var fileContent = param.slice(2).join(" ");
            
            if(!fileName){
              this.addMessageToConsole("Please specify a file name");
              break;
            }

            if(!fileContent){
              fileContent = "";
            }

            allFiles = JSON.parse(window.localStorage.getItem("files"));
            console.log(allFiles);

            if(allFiles.indexOf(fileName) > -1){
              console.log(allFiles);
              this.addMessageToConsole("File "+fileName+" already exists");
              break;
            } else {

              window.localStorage.setItem(fileName, fileContent);
              this.addMessageToConsole("File "+fileName+" created");

              
              allFiles.push(fileName);
              window.localStorage.setItem("files", JSON.stringify(allFiles));
            }
          }
          
          break;
        case "dir":
        case "ll":
        case "ls":
          var result = this.getFiles();
          var that = this;
          result.forEach(function(item){
            that.addMessageToConsole(item);
          });
          if(result.length == 0){
            this.addMessageToConsole("No files found");
          }
          break;
        case "resetfs":
          window.localStorage.clear();
          var demoFiles = ["readme.txt", "hello.js"];
          window.localStorage.setItem("files", JSON.stringify(demoFiles));
          window.localStorage.setItem("readme.txt", "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.");
          window.localStorage.setItem("hello.js", "let hello = 'hello, world';\n console.log(hello);");
          window.localStorage.setItem("ascii.js", "let ascii = ''");
          break;

        case "df":
          var localStorageSize = new Blob(Object.values(localStorage)).size;
          var fiveMb = 5242880;
          var percentage = (fiveMb - localStorageSize) / fiveMb * 100;
          this.addMessageToConsole("Disk size: "+fiveMb+" bytes");
          this.addMessageToConsole("Disk used: "+localStorageSize+" bytes");
          this.addMessageToConsole("Free space: "+percentage.toFixed(2)+"%");
          
          break;
        case "fxhash":
          this.addMessageToConsole("fxhash: "+window.fxhash);
          break;
        case "help":
          this.addMessageToConsole("clear - clears the console");
          this.addMessageToConsole("help - displays this help message");
          this.addMessageToConsole("ls/ll - lists files in the current directory");
          this.addMessageToConsole("cat [file] - displays the contents of a file");
          this.addMessageToConsole("rm [file] - removes a file");
          this.addMessageToConsole("mv [file] [newfile] - moves/rename a file");
          this.addMessageToConsole("run [file] - executes a js file");
          this.addMessageToConsole("resetfs - resets the filesystem to factory defaults");
          this.addMessageToConsole("file [file] [contents] - creates a new file");
          this.addMessageToConsole("df - displays disk usage");
          break;
        default:
          this.addMessageToConsole("Unknown command: "+this.userInput);
          break;
      }

      this.userInput = '';
      this.scrollToElement();
    },
    executeJsFile(file){
      let code = window.localStorage.getItem(file);
      code = code.replaceAll("console.log", "this.addMessageToConsole");
      code = code.replaceAll("<br>", "\n");
      eval(code);
    },

    getFiles(){
      if(window.localStorage.getItem("files") == null){
        let demoFiles = [];
        window.localStorage.setItem("files", JSON.stringify(demoFiles));
        return demoFiles;
      } else {
        return JSON.parse(window.localStorage.getItem("files"));
      }
    },
    checkInputForWord(input, word){
      if(input.includes(word)){
        return input
      } else {
        return false;
      }
    },
    scrollToElement() {
      /*const el = this.$refs.scrollToMe;
      if (el) {
        el.scrollIntoView();
      }*/

      var objDiv = document.getElementById("consoleWindow");
      objDiv.scrollTop = objDiv.scrollHeight;
    },
    keyClick(key){
      switch(key){
        case "enter":
          this.execute();
          break;
        case "up":
          this.userInput = this.userInputLog[this.userInputLog.length - 1];
          break;
        case "down":
          this.userInput = this.userInputLog[this.userInputLog.length];
          break;
        case 'back':
          this.userInput = this.userInput.slice(0, -1);
          break;
        case 'space':
          this.userInput += ' ';
          break;
        default:
          this.userInput += key;
          break;
      }
    },
    setRandomTerminalFontColor(){
      let colors = ['#2ecfff', '#ffb641', '#1bff80', '#c0ffff'];
      let color = colors[this.getRand(0, colors.length - 1)];
      this.$refs.consoleWindow.style.color = color;
      this.terminalFontColor = color;
    },
    setRandomTerminalBackgroundColor(){
      let colors = ['#6d8094', '#000000', '#7F7F7F'];
      let color = colors[this.getRand(0, colors.length - 1)];
      this.$refs.consoleWindow.style.backgroundColor = color;
      this.terminalBackgroundColor = color;
    },
    setRandomScreenRadius(){
      let radii = ['5px', '10px', '15px', '16px', '18px'];
      let radius = radii[this.getRand(0, radii.length - 1)];
      this.$refs.consoleWindow.style.borderRadius = radius;
      this.screenRadius = radius;
    },
    setRandomSmileyFace(){
      let smileys = ['(¬‿¬ )', '٩(◕‿◕｡)۶', 'ヽ(*・ω・)ﾉ', '(￣▽￣)', '(´･ᴗ･ ` )'];
      let smiley = smileys[this.getRand(0, smileys.length - 1)];
      this.smileyFace = smiley;
    },
    getRand(min, max) {
      let value = Math.round(window.fxrand() * (max - min) + min);
      //console.log(value)
      return value;
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
